<script setup lang="ts">
withDefaults(
  defineProps<{
    type:
      | 'primary'
      | 'secondary'
      | 'tertiary'
      | 'quaternary'
      | 'danger'
      | 'passive'
      | 'transparent'
    size: 'xsmall' | 'small' | 'large'
    as: 'button' | 'a' | 'router-link'
    disabled?: boolean
  }>(),
  {
    disabled: false
  }
)
</script>

<template>
  <component
    :is="as"
    class="inline-flex flex-shrink-0 items-center justify-center rounded border py-4 text-lg font-semibold leading-4.5 tracking-tighter disabled:opacity-50"
    :class="{
      'w-full': size === 'large',
      'px-10': size === 'small',
      '!py-2 px-4': size === 'xsmall',
      'border-tt-green bg-tt-green text-black': type === 'primary',
      'border-tt-green text-tt-green': type === 'secondary',
      'border-black/10 text-tt-gray': type === 'tertiary',
      'border-tt-pale/10 text-tt-pale': type === 'quaternary',
      'border-tt-red bg-tt-red text-white': type === 'danger',
      'border-tt-lighter-gray bg-tt-lighter-gray text-black':
        type === 'passive',
      'border-tt-gray bg-transparent': type === 'transparent'
    }"
    :disabled="disabled"
  >
    <slot></slot>
  </component>
</template>
